import { widgetFor } from "../index";
import FormElem from "../../../cardView/FormElem";

/**
 * One element of a stateForm.
 *
 * The widget list is the registry, the same one `ModalForm` reads — not a chain
 * of ternaries. It was three branches until 2026-08-18, and one of them named
 * `selector`, a widget no config had ever declared: two dispatchers that
 * disagreed about what a stateForm could contain, and the disagreement is the
 * only reason a dead widget could stay alive. `lint:components` now checks the
 * registry for reachability, which is only true while the registry is the one
 * place a type is resolved.
 *
 * `elem` and `section` are the same object here — `StateFormView` passes the
 * element as both — so a widget gets the props it expects under either name.
 * Anything not in the registry is a form field and falls through to `FormElem`.
 */
const StateFormElem = ({
    elem,
    entity,
    validated,
    useStore,
    useFormState,
    setSelected,
    section,
    lineId,
    path,
    data,
    onAction,
}) => {
    const Widget = widgetFor(elem?.type)

    if (Widget) return (
        <Widget
            entity={entity}
            validated={validated}
            useStore={useStore}
            useFormState={useFormState}
            section={section}
            element={elem}
            item={elem}
            lineId={lineId}
            path={path}
            setSelected={setSelected}
            data={data}
            onAction={onAction}
        />
    )

    return (
        <FormElem
            item={elem}
            validated={validated}
            lineId={lineId}
            section={elem}
            entity={entity}
            useStore={useStore}
            path={path}
        />
    )
}

export default StateFormElem
